export const SITE_NAME = 'Sitash';
export const SITE_TAGLINE = 'Transforming Education Through Technology';
export const CONTACT_EMAIL = 'Piinfinity.technology@gmail.com';
export const CONTACT_PHONE = '+91 7000642339';
export const COMPANY_ADDRESS = 'A-46, Wazirpur Industrial Area, Delhi';

export const SOCIAL_LINKS = {
  linkedin: 'https://linkedin.com',
  twitter: 'https://twitter.com',
  instagram: 'https://instagram.com',
  facebook: 'https://facebook.com'
};

export const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/services', label: 'Solutions' },
  { path: '/projects', label: 'Products' },
  { path: '/contact', label: 'Contact' }
];